module.exports = __webpack_public_path__ + "static/media/salary-grey.77cbd40d.svg";